import Vue from 'vue';

function initBlogoverview() {

    if (document.querySelector('.blog__overview')) {
        new Vue({
            name: 'ContentBLogs',
            el: '.blog__overview',
            components: {

            },
            data: {
                mobileActiveTemp: '',
                mobileFilter: false,
                blogs: blogs,
                categorieItems: categorieItems,
                filters: filters,
                types: types,
                umbrellas: umbrellas,
                activeItems: [],
                activeItemsFilltered: [],
                activeFilters: [],
                maxItems: 9,
                maxFound: 0,
                opened: undefined,
            },
            methods: {
                consoleLog: function(el) {
                    console.log(filters);
                },
                setActive: function () {
                    var self = this;
                    self.activeItemsFilltered = [];
                    self.activeItemsTemp = [];
                    self.blogs.forEach(function(item){
                        var tempArray = {
                            'id' : item['id'],
                            'date' : item['dateISO'],
                            'headline' : item['headline'],
                            'url' : item['link'],
                            'mediaUrl' : item['image'],
                            'categorieItems' : item['categorieItems'],
                            'umbrellas' : item['umbrellas'],
                            'types' : item['types'],
                        }
                        self.activeItemsTemp.push(tempArray);
                    });
                    self.activeItems = self.activeItemsTemp;
                    if(self.activeFilters.length == 0){

                    }else{
                        self.activeFilters.forEach(function(item){
                            self.activeItemsTemp = [];
                            var filterId = item['value'];
                            var filterType = item['filter'];
                            self.activeItems.forEach(function(item){
                                var categoryIsMatched = false;
                                if(filterType == 'categories'){
                                    item['categorieItems'].forEach(function(item2){
                                        if(item2['blog_category_id'] == filterId || filterId == 0){
                                            categoryIsMatched = true;
                                        }else{

                                        }
                                    });
                                    if(categoryIsMatched == true){
                                        var tempArray = {
                                            'id' : item['id'],
                                            'date' : item['date'],
                                            'headline' : item['headline'],
                                            'url' : item['url'],
                                            'mediaUrl' : item['mediaUrl'],
                                            'categorieItems' : item['categorieItems'],
                                            'umbrellas' : item['umbrellas'],
                                            'types' : item['types'],
                                        }
                                        self.activeItemsTemp.push(tempArray);
                                    }else{

                                    }
                                }
                                if(filterId == item[filterType]){
                                    var tempArray = {
                                        'id' : item['id'],
                                        'date' : item['date'],
                                        'headline' : item['headline'],
                                        'url' : item['url'],
                                        'mediaUrl' : item['mediaUrl'],
                                        'categorieItems' : item['categorieItems'],
                                        'umbrellas' : item['umbrellas'],
                                        'types' : item['types'],
                                    }
                                    self.activeItemsTemp.push(tempArray);
                                }else{

                                }
                            });
                            self.activeItems = self.activeItemsTemp;
                        });
                    }
                    self.maxFound = self.activeItems.length;
                    self.activeItems.forEach(function(item, index){
                        self.activeItems = self.activeItemsTemp;
                        if(self.maxItems > index){
                            var tempArray = {
                                'id' : item['id'],
                                'date' : item['date'],
                                'headline' : item['headline'],
                                'url' : item['url'],
                                'mediaUrl' : item['mediaUrl'],
                                'categorieItems' : item['categorieItems'],
                                'umbrellas' : item['umbrellas'],
                                'types' : item['types'],
                            }
                            self.activeItemsFilltered.push(tempArray);
                        }else{

                        }
                    });
                },
                returnItemName: function (id, array) {
                    var itemName = '';
                    array.forEach(function(item){
                        if(item['id'] == id){
                            itemName = String(item['name']);
                        }
                    });
                    return itemName;
                },
                setActiveFilter: function (filterId, filter) {
                    var self = this;
                    if(filter == 'all'){
                        self.activeFilters = [];
                        self.setActive();
                    }else{
                        var tempArray ={
                            'filter' : filter,
                            'value' : filterId,
                        }
                        var itemsProcessed = 0;
                        if(self.activeFilters.length == 0){
                            self.activeFilters.push(tempArray);
                            self.setActive();
                        }else{
                            self.activeFilters.forEach(function(item,index){
                                if(item['filter'] == filter){
                                    self.activeFilters[index]['value'] = filterId;
                                    self.setActive();
                                    return true;
                                }
                                itemsProcessed++;
                                if(itemsProcessed === self.activeFilters.length) {
                                    self.activeFilters.push(tempArray);
                                    self.setActive();
                                }
                            });
                        }
                    }
                },
                getFilterIndex: function (object, name) {
                    let self = this;
                    let mobileActiveTempIndex = null;
                    if(object != null){
                        Object.keys(object).forEach(key => {
                            if(object[key] == name){
                                mobileActiveTempIndex = key;
                            }
                        });
                    }
                    return mobileActiveTempIndex;
                },
                closeActiveFilter: function (filter) {
                    var self = this;
                    self.activeFilters.forEach(function(item, index){
                        if(item['filter'] == filter){
                            self.activeFilters.splice(index,1);
                        }else{

                        }
                    });
                    self.setActive();
                },
                loadMore: function () {
                    var self = this;
                    self.maxItems = self.maxItems + 3;
                    this.setActive();
                },
                closeDropdown: function(){
                    this.opened = undefined;
                },
                openDropdown: function(index){
                    index == this.opened ? this.opened = undefined : this.opened = index; this.mobileActiveTemp = this.filters[index].active;
                },
            },
            mounted() {
                this.setActive();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    initBlogoverview();
});
window.addEventListener("Pageeditor:insert", function() {
    initBlogoverview();
});
window.addEventListener("Pageeditor:change", function() {
    initBlogoverview();
});
window.addEventListener("Pageeditor:move", function() {
    initBlogoverview();
});